import { Layer } from 'game/components/Layer';
import { message } from 'game/components/Message';
import { Modal, ModalBody } from 'game/components/Modal';
import { createStyles } from 'game/lib/createStyles';

const attributionLinks: Array<{ name: string, author: string, url: string }> = [
  {
    name: 'Free Laser Gun Vector #1',
    author: 'Rizki Kurniawan',
    url: 'https://www.vecteezy.com/vector-art/107386-free-laser-gun-vector-1',
  },
  {
    name: 'Camping Element Vector',
    author: 'xiayamoon',
    url: 'https://www.vecteezy.com/vector-art/245800-camping-element-vector',
  },
  {
    name: 'Bricklayer And Tools Icon Vector',
    author: 'dreamerice',
    url: 'https://www.vecteezy.com/vector-art/112681-bricklayer-and-tools-icon-vector',
  },
  {
    name: 'Free Architect Icons',
    author: 'watchtaxinyc',
    url: 'https://www.vecteezy.com/vector-art/133766-free-architect-icons',
  },
  {
    name: 'Black Hand Silhouette',
    author: 'Eezy Premium',
    url: 'https://www.vecteezy.com/vector-art/54482-black-hand-silhouette',
  },
  {
    name: 'Stick characters posture icon action figures symbols human body silhouettes',
    author: 'onyxprj_art',
    url: 'https://www.vecteezy.com/vector-art/3604491-stick-characters-posture-icon-action-figures-symbols-human-body-silhouettes',
  },
  {
    name: 'Boy and girl in sleeping bags next to tent with campfire and backpack. facilities for tourism, recreation, survival in the wild.',
    author: 'macrovector',
    url: 'https://www.freepik.com/free-vector/boy-girl-sleeping-bags-tent-with-campfire-backpack-facilities-tourism-recreation-survival-wild-vector-illustration_10602373.htm#query=sleeping%20bag&position=8&from_view=keyword',
  },
  {
    name: 'Colorful tourist tents set',
    author: 'macrovector',
    url: 'https://www.freepik.com/free-vector/colorful-tourist-tents-set_4279283.htm',
  },
].sort((a, b) => a.name.localeCompare(b.name));

const classes = createStyles({
  heading: {
    margin: 0,
    marginBottom: 12,
    fontSize: 'inherit',
  },
  list: {
    listStyle: 'disc',
    marginLeft: 16,
    '& > * + *': {
      marginTop: 12,
    },
  },
});

export const Attribution: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  return (
    <Layer>
      <Modal heading={message('Attribution')} onClose={onClose}>
        <ModalBody>
          <h3 className={classes.heading}>
            {message('Free assets used')}:
          </h3>
          <ul className={classes.list}>
            {attributionLinks.map(({ name, author, url }) => (
              <li>
                <a href={url} target="_blank" rel="noreferrer">{name}</a>
                {` ${message('by')} `}
                {author}
              </li>
            ))}
          </ul>
        </ModalBody>
      </Modal>
    </Layer>
  );
};
